export enum TipoUsuario {
  Executivo =	'1',
  ImportarRelatorio = '2',
  Gerente	= '3',
  Tecnologia = '4',
  Operacional = '5',
  GerenteOperacional = '6',
  Advogado = '7',
  Financeiro = '8',
  GerenteExecutivo = '9'
}
